import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CoreH6 from "../dataDisplay/CoreH6";
import { theme } from "../../config/theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  borderRadius: theme.shape.borderRadius + "px",
};

export default function CoreModal(props) {
  const { open, handleClose, children, width = 400, ...restProps } = props;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...style, width }}>
        <CoreH6 id="modal-modal-title" component="h2">
          {props.title}
        </CoreH6>
        <Box>{children}</Box>
      </Box>
    </Modal>
  );
}
